import { ReactNode, useState } from 'react';
import { ReactComponent as InfoIcon } from '../../assets/Icons/adornments/Info.svg';
import { Popover } from '@mui/material';

export default function InfoTooltip({
    btnWidth,
    title,
    content,
}: {
    btnWidth: string,
    title?: string,
    content: ReactNode,
}) {
    const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);

    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const open = Boolean(anchorEl);


    return (
        <div>
            <div className='flex justify-center items-center'>
            <button 
                onClick={handleClick}
                style={{width: btnWidth}} 
                className='text-disable hover:text-primary transition-all'
            >
                <InfoIcon />
            </button>
            </div>
            <Popover
                sx={{
                    '& .MuiPopover-paper': {
                        borderRadius: '8px'
                    }
                }}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'center',
                    horizontal: 'right'
                }}
            >
                <div className='flex flex-col gap-4 p-6'>
                    {title ? (
                        <p className='text-[14px] font-semibold'>{title}</p>
                    ) : (
                        <></>
                    )}
                    {content}
                </div>
            </Popover>
        </div>
    )
}